var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-block cms-block-video"},[_c('video',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.block.value.src,"type":"video/mp4"}}),_vm._v(" "+_vm._s(_vm.$t("Your browser does not support the video tag."))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }